import React, { FC } from 'react';
import { Col, FormFeedback, Input, Label } from 'reactstrap';

interface CheckboxProps {
    field: {
        xs?: string;
        sm?: string;
        md?: string;
        lg?: string;
        xl?: string;
        label: string;
        value: string;
        mandatory?: boolean;
        type: string | any;
        disabled?: boolean;
        maxLen?: number;
        rows?: number;
        label2?:string;
        label1?: string;
        label3?:string;
    };
    labelCss?: string;
    mode: string;
    validation: {
        handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
        handleBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
        values: { [key: string]: string };
        touched: { [key: string]: boolean };
        errors: { [key: string]: string };
    };
    checked: boolean;
}

const Checkbox: FC<CheckboxProps> = (props) => {
    return (
        <Col xs={props.field?.xs} sm={props.field?.sm} md={props.field?.md} lg={props.field?.lg} xl={props.field?.xl}>
            <div className="mt-2">
                {props.field?.label && (
                    <Label htmlFor={props.field?.value} className={`form-label ${props.labelCss && props.labelCss}`}>
                        {props.field.label}
                        {props.mode !== 'view' && <span className="text-danger ps-1"> {props.field.mandatory ? '*' : ''}</span>}
                        {props.mode === 'view' && <span className="ps-1"> :</span>}
                    </Label>
                )}
                {props.mode !== 'view' ? (
                    <>
                        <Input
                            className="me-2 mt-1 cursor-pointer"
                            name={props.field?.value}
                            type={props.field?.type}
                            placeholder={`${'Enter'} ${props.field.label}`}
                            disabled={props.field?.disabled}
                            onChange={props.validation.handleChange}
                            maxLength={props.field?.maxLen}
                            rows={props.field?.rows ? props.field?.rows : 3}
                            onBlur={props.validation.handleBlur}
                            value={props.validation.values[props.field?.value] || ''}
                            checked={props.checked}
                            invalid={
                                props.validation.touched[props.field?.value] && props.validation.errors[props.field?.value] ? true : false
                            }
                        />
                        <Label className='classA'>{props?.field?.label1}</Label>
                        <Label className='font-weight-500'>{props?.field?.label2}</Label>
                        <Label className='font-weight-300'>{props?.field?.label3}</Label>
                    </>
                ) : (
                    <span> {props.validation.values[props.field?.value] ? 'Yes' : 'No'}</span>
                )}

                {props.validation.touched[props.field?.value] && props.validation.errors[props.field?.value] ? (
                    <FormFeedback type="invalid">
                        <div>{props.validation.errors[props.field?.value]}</div>
                    </FormFeedback>
                ) : null}
            </div>
        </Col>
    );
};

export default Checkbox;
